import React from 'react';
import Label from '../../typography/Label';
import ListBorders from '../../layout/ListBorders';
import useComponentMargin from '../../hooks/useComponentMargin';
const LabeledFieldset = ({ name, displayName, children, initiallyShow = false, hasErrors = false, required = false, disabled = false, noBorders = false, noExtraMargin = false, styles, className }) => {
    const resetStyles = {
        border: 0,
        margin: 0,
        padding: 0
    };
    const marginStyles = useComponentMargin({
        ...(!noExtraMargin && { marginVertical: 'small' }),
        ...(!hasErrors && !initiallyShow && { marginBottom: 'regular' })
    });
    const mergedStyles = {
        ...resetStyles,
        ...marginStyles,
        ...styles
    };
    return (React.createElement("fieldset", { style: mergedStyles, className: className },
        displayName && (React.createElement(Label, { role: "label", htmlFor: name, required: required, disabled: disabled }, displayName)),
        noBorders ? (children) : (React.createElement(ListBorders, { marginVertical: "small", hasErrors: hasErrors }, children))));
};
export default LabeledFieldset;
//# sourceMappingURL=index.js.map